import styled from "styled-components";

import {GamePlayPcHeaderBarSectionPartBox} from "../../game-play-pc-header-bar-section-part.box";

export const GamePlayPcHeaderBarTopRightEndSectionBox = styled(GamePlayPcHeaderBarSectionPartBox)`
  
`